import { all, call, fork, put, takeLatest } from "redux-saga/effects"

//Account JOB Management
import { ADD_EMAIL_TEMPLATE, EDIT_EMAIL_TEMPLATE, EMAIL_TEMPLATE_DETAILS, GET_DEFAULT_EMAIL_TEMPLATE_DATA } from "./actionTypes"
import {
    emailAddTemplateFailed,
    emailAddTemplateSuccess,
    emailEditTemplateFailed,
    emailEditTemplateSuccess,
    emailTemplateDetailsFailed,
    emailTemplateDetailsSuccess,
    getEmailDefaultTemplateFail,
    getEmailDefaultTemplateSuccess
} from "./actions"

import {
    getCall, postCall, putCall
} from "../../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../../common/constant/constantURL"

function* getEmailTemplateDetails() {
    try {
         let responsJSON = yield call(getCall, constClass.REST_API_EMAIL_TEMPLATE_TITLE);
        yield put(emailTemplateDetailsSuccess(responsJSON))
    } catch(error) {
        yield put(emailTemplateDetailsFailed(error))
    }
}

 function* addEmailTemplate(request) 
   {
    try {   
         let responsJSON = yield call(postCall, constClass.REST_API_EMAIL_TEMPLATE_ADD, request?.payload);
         if(responsJSON !== undefined && responsJSON !== null){
            yield put(emailAddTemplateSuccess(responsJSON))
         }
         else{
            yield put(emailAddTemplateSuccess("success"))
         }
    } catch(error) {
        yield put(emailAddTemplateFailed(error))
    }
}

function* editEmailTemplate(request) {
    try {
      
         let responsJSON = yield call(putCall, constClass.REST_API_EMAIL_TEMPLATE_ADD, request.payload);
        yield put(emailEditTemplateSuccess(responsJSON))
    } catch(error) {
        yield put(emailEditTemplateFailed(error))
    }
}

function* getDefaultEmailTemplateHandler(request){
         try{
            let responsJSON = yield call(getCall, constClass.REST_API_EMAIL_TEMPLATE_TITLE+"/"+request.payload);
            yield put(getEmailDefaultTemplateSuccess(responsJSON))        
        }
         catch(error){
            getEmailDefaultTemplateFail(error)
         }
}


export function* watchEmailTemplateSaga() {
    yield takeLatest(EMAIL_TEMPLATE_DETAILS, getEmailTemplateDetails)
    yield takeLatest(ADD_EMAIL_TEMPLATE, addEmailTemplate)
    yield takeLatest(EDIT_EMAIL_TEMPLATE,editEmailTemplate)
    yield takeLatest( GET_DEFAULT_EMAIL_TEMPLATE_DATA, getDefaultEmailTemplateHandler)
}

function* emailTemplateConfigurationSaga() {
    yield all([fork(watchEmailTemplateSaga)])
}
export default emailTemplateConfigurationSaga